import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-request-manage',
  templateUrl: './consumerCenter.component.html'
})
export class consumerCenterComponent implements OnInit {
	
	constructor() { }

  ngOnInit() {
	 
  }
  
 

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/consumerCenter/consumerCenter.component.ts